import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { GenericType } from "@/types";
import { CloudUploadIcon, FileTextIcon, X } from "lucide-react";

export const UploadInputV2 = ({ value, onChange }: GenericType) => {
  return (
    <div className="relative border-2 text-center flex items-center justify-center flex-col h-[150px] gap-3 border-dashed w-full rounded-md cursor-pointer">
      <ConditionRenderer condition={value?.name ? true : false}>
        <div className="flex items-center flex-col gap-3 relative">
          <FileTextIcon size={40} className="text-slate-500" />
          <div className="text-center text-slate-600 text-[18px] relative flex gap-2 items-center">
            {value?.name}
            <Button
              variant={"ghost"}
              className="relative z-[99]"
              size={"icon"}
              type="button"
              onClick={() => onChange(undefined)}
            >
              <X />
            </Button>
          </div>
        </div>
        <div className="text-center text-slate-600 text-[18px] relative flex gap-2 items-center flex-col">
          <CloudUploadIcon size={40} className="text-slate-500" />
          <div className="text-center text-slate-600 text-[18px]">
            Select a file
          </div>
        </div>
      </ConditionRenderer>
      <Input
        className="absolute left-0 top-0 w-full h-full opacity-0"
        type="file"
        onChange={(e) => onChange(e?.target?.files?.[0])}
      />
    </div>
  );
};
